<template>
    <footer class="footer">
        <div class="container">
            <div class="gr-12">
                <div class="footer__inner">
                    <div class="footer__copyright">
                        <p>Copyright 2019 Dizajn i vizualizacija d.o.o. Čret 28, 10 000 Zagreb, Croatia</p>
                    </div>

                    <div class="footer__branding">
                        <p>Created using magic by <a href="https://social-wizard.com/" target="_blank">Social Wizard </a> <i class="icon-sw"></i></p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        name: 'footer-comp',

        data() {
            return {}
        }
    };
</script>


<style scoped lang="scss">
    @import "@/scss/modules/_footer.scss";
</style>